export const binaryFile = {
  type: 'string',
  minLength: 1,
  maxLength: 255,
};
